<template>
  <v-card class="mt-6">
    <v-card-title>
      Alerta de Auditoria
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-switch
            :value="config.audit_alert_enabled"
            color="primary"
            inset
            label="Ativar"
            @change="updateField('audit_alert_enabled', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.audit_alert_time"
            type="time"
            outlined
            :error="auditAlertInput.error"
            :error-messages="auditAlertInput.message"
            :disabled="!config.audit_alert_enabled"
            label="Horário"
            @input="updateField('audit_alert_time', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.audit_alert_interval"
            type="number"
            outlined
            :error="auditAlertIntervalInput.error"
            :error-messages="auditAlertIntervalInput.message"
            :disabled="!config.audit_alert_enabled"
            label="Intervalo entre alertas (min)"
            @input="updateField('audit_alert_interval', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AuditAlertSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
    auditAlertInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
    auditAlertIntervalInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
